import __request__ from "routing/request";
export function getUsersForRole(sort = "name", roleId, page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.security/authz/roles/${roleId}/teams`, null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function addRoleToTeams(roleId, teamIds, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.security/authz/roles/${roleId}/teams/add`, teamIds, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function removeRoleFromTeam(roleId, teamId, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.security/authz/roles/${roleId}/teams/remove`, teamId, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
